import React from 'react';
import styled, { css } from 'styled-components/macro';
import Drawer from '../components/Drawer';
import Buscador from '../components/Buscador';
import BuscadorMobile from '../components/BuscadorMobile';
import { useIsMobile, useIsDesktop } from '../hooks/useMediaQuery';
import { useTranslate } from '../contexts/languageContext';
import { NotificationButton } from '../components/NotificationButton';
import LogoRegistraduriaSmall from '../assets/img/logo_org-120w.png';
import LogoRegistraduriaBig from '../assets/img/logo_org.png';
import LowerBanner from '../containers/LowerBanner';
import DropdownHistorico from './DropdownHistorico';
import DatosDeEnvio from './DatosDeEnvio';
import { ReactComponent as Hamburguesa } from '../assets/img/IconHamburguesa.svg';
import { Link } from 'react-router-dom';
import { ReactComponent as IconReset } from '../assets/img/IconReset.svg';
import { getUrl, getParents } from '../utils';
import LogoEleccion from '../assets/img/logoEleccion.png';
import { responsive } from '../resources/constantes.json';
import {  useMesa } from '../contexts/pageContext';

/**
 * Header (cabecera) que se muestre al inicio de cada página  que nos informa de la
 * página a la que hemos accedido
 */

const Header = ({ variant, ...rest }) => {
  switch (variant) {
    case 'resultados':
      return <HeaderResultados {...rest} />;
    case 'estadisticas':
      return <HeaderEstadisticas {...rest} />;
    default:
      throw new Error();
  }
};

const HeaderResultados = ({
  nomenclator,
  eleccion,
  children,
  page,
  data,
  ambito,
  esHistorico,
  urlInfo,
  datoFecha,
}) => {
  const t = useTranslate();
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();
  const nomAmbitos = nomenclator.nomAmbitos[eleccion];
  const mesa = useMesa();
  let nombreAmbito;
  if(mesa){
    nombreAmbito = `MESA ${Number(mesa.slice(1, 7))}`;
  } else {
    nombreAmbito = nomenclator.ambitos[eleccion].find(y => y.c === data.amb).n;
    }
  const ColorPrimeraFila = esHistorico ? '#646464' : '#1C283D';
  const ColorSegundaFila = esHistorico ? '#646464' : '#1C283D';
  const ColorHeader = esHistorico ? '#646464' : '#1C283D';
  const esBoletin = data.tope === '1';
  const LinkAmbitoPadre = () => {
    const parent = urlInfo && urlInfo.parentLevel ? urlInfo.parentLevel : 0;
    const parents = getParents(
      ambito.i,
      eleccion,
      nomenclator,
      parent
    ).reverse();
    const ids = [...parents, ambito.i].slice(-2);
    const routes = ids.map(id => ({
      url: getUrl({ id, eleccion, nomenclator, page, parent }),
      n: nomenclator.ambitos[eleccion][id].n,
    }));
    return (
      <>
        {routes.length > 1 && (
          <SLink to={routes[0].url}>
            <IconReset />
          </SLink>
        )}
      </>
    );
  };
  return (
    <>
      {!isMobile ? (
        <SHeader esHistorico={esHistorico} ColorHeader={ColorHeader}>
          <LeftSide>
            <SHigherBanner>
              {esHistorico ? (
                <SHeadingPagina>{children}</SHeadingPagina>
              ) : (
                <>
                  <SCajaHamburguesa>
                    <Drawer
                      icon={<Hamburguesa width={44} height={44} />}
                      page={page}
                    />
                  </SCajaHamburguesa>
                  <SHeadingPagina>{children}</SHeadingPagina>
                </>
              )}
            </SHigherBanner>
            <LowerBanner
              eleccion={eleccion}
              esHistorico={esHistorico}
              data={data}
              page={page}
              nomenclator={nomenclator}
              ambito={ambito}
              {...urlInfo}
            />
          </LeftSide>
          {!isMobile && (
            <RightSide>
              <DatosDeEnvio datoFecha={data.mdhm} />
              <SLogoBanner>
                <img src={LogoEleccion} alt={'Logo elección'} />
                <div className="visually-hidden">{t('logoEleccion')}</div>
              </SLogoBanner>
            </RightSide>
          )}
        </SHeader>
      ) : (
        <ContenedorHeaderResponsive>
          <ContenedorPrimeraFila ColorPrimeraFila={ColorPrimeraFila}>
            {esHistorico ? (
              <SHeadingPagina>{children}</SHeadingPagina>
            ) : (
              <>
                <HambuguesaNombre>
                  <SCajaHamburguesa>
                    <Drawer
                      icon={
                        <Hamburguesa
                          // fill={'#1c283d'}
                          width={44}
                          height={44}
                        />
                      }
                      page={page}
                    />
                  </SCajaHamburguesa>
                  <SHeadingPagina>{children}</SHeadingPagina>
                </HambuguesaNombre>
                {!esHistorico && (
                  <ContainerBuscador>
                    <SBuscadorMobile
                      nomenclator={nomenclator}
                      eleccion={eleccion}
                      ambito={ambito}
                      page={page}
                    />

                    <SCajaNotificacion>
                      <NotificationButton nomenclator={nomenclator} />
                    </SCajaNotificacion>
                  </ContainerBuscador>
                )}
              </>
            )}
          </ContenedorPrimeraFila>
          <ContenedorSegundaFila ColorSegundaFila={ColorSegundaFila}>
            <NombreAmbito>
              {!esHistorico && LinkAmbitoPadre()}
              {nombreAmbito}
            </NombreAmbito>
            <DatosDeEnvio datoFecha={data.mdhm} />
          </ContenedorSegundaFila>
          <ContenedorTerceraFila>
            <ContenedorInfoMesas>
              <p> Mesas Informadas </p>
              <TextoMesasInf>{data.totales.act.pmesesc}</TextoMesasInf>
            </ContenedorInfoMesas>
            <div>
              {esHistorico ? (
                <span
                  css="font-weight: bold;
                   text-transform: uppercase;
                   padding: 20px;
                   box-sizing: border-box;
                   display: flex;
                   align-items: center;
                   justify-content: space-between;
                   max-width: 200px;
                   "
                >{`${esBoletin ? t('boletin') : t('avance')} ${
                  data.numact
                }`}</span>
              ) : (
                <DropdownHistorico
                  data={data}
                  items={data.historico}
                  id={ambito.i}
                  eleccion={eleccion}
                  nomenclator={nomenclator}
                  page={page}
                  tope={data.tope}
                  {...urlInfo}
                />
              )}
            </div>
          </ContenedorTerceraFila>
        </ContenedorHeaderResponsive>
      )}
    </>
  );
};

const HeaderEstadisticas = ({ children, page, nomenclator }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  return (
    <SHeader ColorHeader='#1c283d'>
      <SHigherBanner width="70%">
        <SCajaHamburguesa>
          <Drawer
            icon={
              <Hamburguesa
                // fill={'#1c283d'}
                width={44}
                height={44}
              />
            }
            page={page}
          />
        </SCajaHamburguesa>
        <SHeadingPagina>{children}</SHeadingPagina>
        {/*   <Nav /> */}
      </SHigherBanner>
      {isDesktop && (
        <SLogoBanner width="30%">
          <LogoRegistraduria />
          <img src={LogoEleccion}  alt={'Logo elección'} />
          <div className="visually-hidden">{t('logoEleccion')}</div>
        </SLogoBanner>
      )}
    </SHeader>
  );
};

export default Header;

const LeftSide = styled.div`
  width: 70%;
  @media (max-width: ${responsive.tablet}px) {
    width: 60%;
  }
  
  
`;
const RightSide = styled.div`
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 124px;
  @media (max-width: ${responsive.tablet}px) {
    width: 40%;
  }
  
`;

const SLogoEleccion = styled(LogoEleccion)`
  height: 100%;
`;

const SHeader = styled(({ esHistorico, ColorHeader, ...rest }) => (
  <header {...rest} />
))`
  width: 100%;
  //max-width: 1366px;
  background:  ${({ ColorHeader }) => ColorHeader};
  margin: auto;
  margin-top:0;
  margin-bottom:0;
  flex: 0 0 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1000;
  @media (max-width: 1024px) {
    ${({ esHistorico }) =>
      !esHistorico &&
      css`
        position: fixed;
        background: #1C283D;
        box-shadow: 0px 1px 0 rgba(0, 0, 0, 0.2), 0px 2px 3px rgba(0, 0, 0, 0.2);
      `}
    top: 0;
  }
  @media (max-width: 768) {
    flex: 0 0 50px;
  @media print {
    box-shadow: none;
    background-color: transparent;
    @media print {
      position: relative;
    }
  }
`;

const SHigherBanner = styled(({ width, ...rest }) => <div {...rest} />)`
  flex: 1 0 ${({ width }) => width};
  height: 60px;
  display: flex;
  align-self: flex-start;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding-left: 3%;
  @media (max-width: 768px) {
    padding-left: 0px;
  }
  @media print {
    display: none;
  }
`;

const SLogoBanner = styled(({ width, ...rest }) => <div {...rest} />)`
  margin-right: 3vw;
  @media (max-width: 768px) {
    height: 50px;
  }
  img {
    @media (max-width: 1024px) {
      height: 100px;
    }
  }
`;

const SCajaHamburguesa = styled.div`
  flex: 0 0 44px;
  height: 44px;
  border-radius: 20px;
  @media (max-width: 768px) {
    flex: 0 0 50px;
    height: 50px;
    border-radius: 0;
  }
`;

const HeadingPagina = props => <h1 data-testid="heading" {...props} />;
const SHeadingPagina = styled(HeadingPagina)`
  font-weight: 500;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 16px;
  min-width: 187px;
`;

const SCajaNotificacion = styled(({ push, ...rest }) => <div {...rest} />)`
  flex: 0 0 60px;
  height: 60px;
  background-color: transparent;
  align-self: flex-end;
  margin-left: ${({ push }) => (push ? 'auto' : undefined)};
  button {
    background-color: transparent;
  }

  /*necesario poner width y height para el elemento svg para IE11*/
  svg {
    width: 44px;
    height: 44px;
    fill: #1c4183;
  }
  @media (max-width: 768px) {
    flex: 0 0 50px;
    height: 50px;
    /*necesario poner width y height para el elemento svg para IE11*/
    svg {
      width: 50px;
      height: 50px;
      fill: #1c4183;
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    svg {
      fill: #fff;
    }
  }
`;

const SBuscador = styled(Buscador)`
  margin-left: auto;
  align-self: flex-end;
  height: 44px;
  flex: 0 2 300px;
  //background-color: #fff;
  //border-radius: 30px;
`;

const SBuscadorMobile = styled(BuscadorMobile)`
  margin-left: auto;
  align-self: flex-end;
  height: 100%;
  flex: 0 0 50px;
  background-color: white;
  height: 50px;
`;

const LogoRegistraduria = () => {
  const t = useTranslate();
  return (
    <SLogoRegistraduria>
      <img
        src={LogoRegistraduriaSmall}
        alt={t('logoReg')}
        srcSet={`${LogoRegistraduriaSmall}, 
                ${LogoRegistraduriaBig} 2x`}
      />
    </SLogoRegistraduria>
  );
};
const SLogoRegistraduria = styled.figure`
  & img {
    vertical-align: middle;
    display: none;
  }
  @media (max-width: 768px) {
    margin: 0 auto;
    padding: 20px;
  }
`;

// HEARDER RESPONSIVE

const ContenedorHeaderResponsive = styled.div`
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const ContenedorPrimeraFila = styled(({ ColorPrimeraFila, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  height: 51px;
  display: flex;
  align-self: flex-start;
  flex-direction: row;
  align-items: center;
  padding-left: 0px;
  box-sizing: border-box;
  background: ${({ ColorPrimeraFila }) => ColorPrimeraFila};
  justify-content: space-between;
`;

const ContenedorSegundaFila = styled(({ ColorSegundaFila, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  height: 51px;
  display: flex;
  align-self: flex-start;
  flex-direction: row;
  align-items: center;
  padding-left: 0px;
  box-sizing: border-box;
  background: ${({ ColorSegundaFila }) => ColorSegundaFila};
  background:#1C283D;
  justify-content: space-between;
  border-top: 1px solid white;
`;

const ContenedorTerceraFila = styled(({ ...rest }) => <div {...rest} />)`
  display: flex;
  height: 51px;
  display: flex;
  align-self: flex-start;
  flex-direction: row;
  align-items: center;
  padding-left: 0px;
  box-sizing: border-box;
  background: #fff;
  justify-content: space-between;
`;

const NombreAmbito = styled.p`
  color: #fff;
  margin-left: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const ContenedorInfoMesas = styled.div`
  margin-left: 10px;
`;

const TextoMesasInf = styled.div`
  font-weight: 800;
  font-size: 16px;
`;

const HambuguesaNombre = styled.div`
  display: flex;
  align-items: center;
`;

const ContainerBuscador = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

const SLink = styled(Link)`
  margin-right: 5px;
  display: flex;
  
`;
